let _mode = 'mock';

export const setApiMode = (m) => { _mode = m; };
export const getApiMode = () => _mode;
export const isMockMode = () => _mode === 'mock';
